import styled from '@emotion/styled';
import { opacify } from 'polished';

import {
  dimensions,
  breakpoints,
  flex,
  colors,
  hiddenWhenSmall,
} from '@parapet/common';

export const StyledPublicComponent = styled.div`
  width: 100%;
  height: 100vh;
  ${flex};
  flex-direction: column;
  .Logo {
    width: 120px;
    margin-top: ${dimensions.spacerLarge};
    opacity: 0.32;
  }
`;

export const PublicComponentContent = styled.div`
  background-color: ${opacify(1, colors.gray.dark)};
  box-shadow: 0 4px 40px -4px #0003;
  border-radius: var(--border-radius-lg);
  width: 460px;
  padding: ${dimensions.spacerLarge};
  position: relative;
  z-index: 9;
  color: #ccc;
  a {
    color: #fff;
    text-decoration: none;
    padding-bottom: 2px;
    border-bottom: 1px solid var(--primary-500);
    &:hover {
      border-bottom-color: transparent;
    }
  }
  @media (max-width: ${breakpoints.lg}) {
    padding: ${dimensions.spacer};
  }
  &:before {
    content: '';
    width: 600px;
    height: 600px;
    opacity: 0.2;
    background-color: ${colors.brand};
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    margin: -300px 0 0 -300px;
    border-radius: 1000px;
    filter: blur(100px);
    animation: fadeIn 1s ease;
    ${hiddenWhenSmall};
    pointer-events: none;
  }

  h4 {
    color: #fff;
    margin-top: 0;
  }
  p {
    width: 80%;
    font-size: ${dimensions.fontSize.medium}px;
    margin: 0 auto ${dimensions.spacer} auto;
    color: #999;
  }
  @media (max-width: ${breakpoints.lg}) {
    background-color: transparent;
    width: 100%;
    box-shadow: none;
  }
`;
